export enum BlocksTableType {
  Mobile,
  DesktopLite,
  Desktop,
}
